<template>
  <div v-frag class="prism-elite-app">
    <CardIeaAppMain colorCard="#0F172A" title="">
      <v-col cols="12" class="pa-0 main-container-glass">
        
        <!-- Top Bar -->
        <div class="prism-top-bar d-flex align-center justify-space-between px-8 py-5">
           <div class="d-flex align-center">
            <v-btn
              icon
              @click="$router.push({ name: 'Home' })"
              class="mr-4 glass-btn"
              large
            >
              <v-icon color="primary">mdi-arrow-left-circle-outline</v-icon>
            </v-btn>
             <div>
              <h1 class="text-h6 font-weight-black prism-title mb-0">{{ title }}</h1>
              <div class="text-caption grey--text font-weight-medium">Configura tu experiencia y privacidad en la plataforma</div>
            </div>
           </div>
        </div>

        <v-divider class="prism-divider"></v-divider>

        <div class="pa-8 pb-16">
           <v-row>
             <!-- Privacy Settings -->
             <v-col cols="12" md="7">
                <div class="glass-card-heavy rounded-xl pa-0 overflow-hidden border shadow-soft-elite mb-8">
                   <div class="pa-8 pb-4">
                      <div class="d-flex align-center mb-1">
                         <v-icon color="primary" class="mr-3">mdi-shield-account</v-icon>
                         <h2 class="prism-heading text-h5 font-weight-black">Privacidad y Perfil</h2>
                      </div>
                      <p class="text-body-2 grey--text font-weight-medium">Controla qué información es visible para otros compañeros en tu perfil público.</p>
                   </div>

                   <v-list class="pa-0 elite-list" flat>
                      <v-list-item class="px-8 py-5 border-bottom">
                         <v-list-item-content>
                            <v-list-item-title class="font-weight-bold grey--text text--darken-3 mb-1">Mostrar Biografía</v-list-item-title>
                            <v-list-item-subtitle class="grey--text">Muestra tu descripción personal y experiencia en tu perfil.</v-list-item-subtitle>
                         </v-list-item-content>
                         <v-list-item-action>
                            <v-switch v-model="settings.showDescription" color="primary" inset dense hide-details></v-switch>
                         </v-list-item-action>
                      </v-list-item>

                      <v-list-item class="px-8 py-5 border-bottom">
                         <v-list-item-content>
                            <v-list-item-title class="font-weight-bold grey--text text--darken-3 mb-1">Fecha de Nacimiento</v-list-item-title>
                            <v-list-item-subtitle class="grey--text">Permite que otros vean tu fecha de cumpleaños.</v-list-item-subtitle>
                         </v-list-item-content>
                         <v-list-item-action>
                            <v-switch v-model="settings.showNacimiento" color="primary" inset dense hide-details></v-switch>
                         </v-list-item-action>
                      </v-list-item>

                      <v-list-item class="px-8 py-5 border-bottom">
                         <v-list-item-content>
                            <v-list-item-title class="font-weight-bold grey--text text--darken-3 mb-1">Estado Civil</v-list-item-title>
                            <v-list-item-subtitle class="grey--text">Muestra tu situación sentimental actual.</v-list-item-subtitle>
                         </v-list-item-content>
                         <v-list-item-action>
                            <v-switch v-model="settings.showEstadoCivil" color="primary" inset dense hide-details></v-switch>
                         </v-list-item-action>
                      </v-list-item>

                      <v-list-item class="px-8 py-5">
                         <v-list-item-content>
                            <v-list-item-title class="font-weight-bold grey--text text--darken-3 mb-1">Ver toda la actividad</v-list-item-title>
                            <v-list-item-subtitle class="grey--text">Si está activo, verás publicaciones de todas las categorías disponibles.</v-list-item-subtitle>
                         </v-list-item-content>
                         <v-list-item-action>
                            <v-switch v-model="settings.showAll" color="primary" inset dense hide-details></v-switch>
                         </v-list-item-action>
                      </v-list-item>
                   </v-list>
                </div>

                <!-- Interests Section (Conditional) -->
                <v-expand-transition>
                  <div v-if="!settings.showAll" class="glass-card-heavy rounded-xl pa-8 border shadow-soft-elite">
                     <div class="d-flex align-center mb-6">
                        <v-icon color="primary" class="mr-3">mdi-star-face</v-icon>
                        <h2 class="prism-heading text-h5 font-weight-black">Mis Intereses</h2>
                     </div>
                     <p class="text-body-2 grey--text font-weight-medium mb-8">Selecciona las categorías que te gustaría ver en tu muro principal.</p>

                     <div class="grid-categories">
                        <div v-for="(category, index) in allCategories" :key="index" 
                             class="glass-card-interactive rounded-xl pa-4 d-flex align-center border mb-4"
                             :class="{'category-selected': selected.includes(category.id)}">
                           <v-checkbox v-model="selected" :value="category.id" color="primary" hide-details class="mt-0 pt-0 mr-3"></v-checkbox>
                           <div class="flex-grow-1 overflow-hidden">
                              <div class="font-weight-black text-body-2 grey--text text--darken-4 line-height-1 mb-1">{{ category.name }}</div>
                              <div class="text-caption grey--text text-truncate">{{ category.tags }}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                </v-expand-transition>
             </v-col>

             <!-- Actions Sidebar -->
             <v-col cols="12" md="5">
                <div class="sticky-sidebar">
                   <div class="glass-card-heavy rounded-xl pa-8 border shadow-soft-elite mb-6">
                      <h3 class="prism-heading text-h6 font-weight-black mb-4">¿Todo listo?</h3>
                      <p class="text-body-2 grey--text font-weight-medium mb-8">Guarda tus cambios para actualizar tu perfil y personalizar tu feed de actividades.</p>
                      
                      <v-btn
                        color="primary"
                        x-large
                        block
                        class="rounded-xl font-weight-black shadow-glow"
                        @click="save()"
                      >
                         <v-icon left>mdi-content-save-check</v-icon>
                         GUARDAR AJUSTES
                      </v-btn>
                   </div>
                   
                   <v-alert
                    colored-border
                    border="left"
                    icon="mdi-information-outline"
                    class="rounded-xl glass-card-heavy border elite-alert"
                    elevation="2"
                   >
                    Tu seguridad es importante. Los cambios en la privacidad pueden tardar unos segundos en reflejarse globalmente.
                   </v-alert>
                </div>
             </v-col>
           </v-row>
        </div>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "ConfiguracionElite",
  components: {
    CardIeaAppMain,
  },

  data: () => ({
    title: "Configuración",
    settings: {
      showDescription: false,
      showNacimiento: false,
      showEstadoCivil: false,
      showAll: true
    },
    allCategories: [],
    selected: []
  }),

  mounted() {
    this.loadData();
  },

  methods: {
    async loadData() {
      this.$API
        .get({
          url: "alumno/getAlumno"
        }).then((res) => {
          if (res.settings) this.settings = res.settings;
          if (res.categories) {
            this.selected = res.categories.map((v) => v.category_id);
          }
        });

      this.$API
        .get({
          url: "publications-categories"
        }).then((res) => {
          this.allCategories = res || [];
        });
    },

    async save() {
      var formData = new FormData();
      formData.append('settings', JSON.stringify(this.settings));
      formData.append('categories', this.selected);
      
      await this.$API
        .post({
          url: "profile",
          data: formData
        }).then(res => {
            if (res.categories) {
              this.selected = res.categories.map((v) => v.category_id);
            }
            alert("Ajustes guardados correctamente.");
        });
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Outfit:wght@700;900&display=swap");

.prism-elite-app {
  font-family: "Inter", sans-serif !important;
  background: radial-gradient(circle at 100% 100%, #0f172a 0%, #1e293b 100%);
  min-height: 100vh;
}

h1, h2, h3, .prism-heading, .text-overline {
  font-family: "Outfit", sans-serif !important;
  letter-spacing: -0.5px;
}

.main-container-glass {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  min-height: 90vh;
}

.prism-top-bar { background: transparent; }
.prism-divider { border-color: rgba(0,0,0,0.05) !important; }

/* Elite Alert Style */
.elite-alert {
  border-width: 0 0 0 6px !important;
}

/* Glass Cards */
.glass-card-heavy {
  background: white;
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.05) !important;
  border: 1px solid rgba(0,0,0,0.05) !important;
}

.glass-card-interactive {
  background: white;
  border: 1px solid #f1f5f9 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05) !important;
}

.glass-card-interactive:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 40px -15px rgba(26, 35, 126, 0.1) !important;
  border-color: #1a237e !important;
}

.category-selected {
  border-color: #1a237e !important;
  background-color: rgba(26, 35, 126, 0.01) !important;
}

.shadow-soft-elite {
  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03) !important;
}

/* List Style */
.border-bottom {
  border-bottom: 1px solid #f1f5f9 !important;
}

.shadow-glow {
  box-shadow: 0 10px 20px -5px rgba(26, 35, 126, 0.3) !important;
}

.line-height-1 { line-height: 1.25; }

.sticky-sidebar {
  position: sticky;
  top: 2rem;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .prism-top-bar { padding: 1.5rem !important; }
  .sticky-sidebar { position: static; }
}
</style>
